import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=417e68f3&"
import script from "./Page.vue?vue&type=script&lang=js&"
export * from "./Page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('417e68f3')) {
      api.createRecord('417e68f3', component.options)
    } else {
      api.reload('417e68f3', component.options)
    }
    module.hot.accept("./Page.vue?vue&type=template&id=417e68f3&", function () {
      api.rerender('417e68f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/User/Page.vue"
export default component.exports